import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-115b2f31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Similar_target" }
const _hoisted_2 = { class: "select" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "理赔库对比结果", -1))
const _hoisted_5 = { class: "tabs_content" }
const _hoisted_6 = { class: "tab_title" }
const _hoisted_7 = { class: "l_f" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "l_title" }, "养殖户: ", -1))
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "l_title" }, "政策投保单号: ", -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "l_title" }, "商业投保单号: ", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "l_title" }, "理赔案件: ", -1))
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "l_title" }, "标的编号: ", -1))
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "l_title" }, "相似度: ", -1))
const _hoisted_20 = {
  key: 0,
  class: "r_f"
}
const _hoisted_21 = {
  key: 0,
  class: "cowDetail"
}
const _hoisted_22 = { class: "cell-item title" }
const _hoisted_23 = { class: "cowImgs" }
const _hoisted_24 = {
  key: 1,
  class: "cowDetail otherDetail"
}
const _hoisted_25 = { class: "cell-item title" }
const _hoisted_26 = {
  key: 0,
  class: "cowImgs"
}
const _hoisted_27 = {
  key: 1,
  class: "cowImgs flex"
}
const _hoisted_28 = {
  class: "video",
  controls: "",
  style: {"width":"200px","height":"100px"}
}
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "pageination"
}
const _hoisted_31 = { class: "demo-image__preview" }

import { nextTick, ref, toRef, onMounted, watch, computed } from "vue";
import { tabsPageBase } from '@/utiles/utiles'
interface ResultTitle {
    [key: string]: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PayTarget',
  props: ['form', 'targetInfo', 'targetType','cosUrl','ossUrl'],
  setup(__props) {

const { form, targetInfo,  targetType,cosUrl,ossUrl } = __props;


const resultTitle: ResultTitle = {
    NORMAL: '唯一理赔标的',
    REPEAT: '重复理赔标的',
};
const otherDetail = {
    '0': '其他照片',
    '1': '视频',
}

let activeName = ref('')
const previewList = ref([]);
const tabsPage = ref(1)
const tabsPageSize = ref(tabsPageBase.pageSize)
const showViewer = ref(false);
const setPicName = (picType: string) => {
    return picType == "FACE"
        ? "正脸:"
        : picType == "NOSE"
            ? "鼻纹:"
            : picType == "LEFT_FACE"
                ? "侧脸:"
                : picType == "RIGHT_FACE"
                    ? "右侧脸:"
                    : "";
};
onMounted(async () => {
    await nextTick()
    if (targetType == 'audited') {
        activeName.value = form.payTargetId
    } else {
        activeName.value = payTargetAndpayTargetLow.value.length > 0 ? payTargetAndpayTargetLow.value[0].id : ''
    }
  console.log('targetInfo--simTarget',targetInfo.simTarget,cosUrl,ossUrl)
})
let payTargetAndpayTargetLow = computed<any[]>(()=>{
    return [...targetInfo.payTarget.map((v:any)=>{
        v.isExcThreshold = false
        return v
    }),...targetInfo.payTargetLow.map((v:any)=>{
        v.isExcThreshold = true
        return v
    })]
})
const payTarget = computed(()=>{
    console.log('payTargetAndpayTargetLow', payTargetAndpayTargetLow)
    if(targetType === 'audited'){
        return payTargetAndpayTargetLow.value.filter( (n:any) => form.payTargetId === n.id)
    }else{
      return payTargetAndpayTargetLow.value || []
    }
})


const payStatus = computed(() => { return targetInfo?.targetInfo?.targetStatus || '' })
const isShowSimTarget = computed(() => { return targetType == 'AuditPage' ? (targetInfo?.targetInfo?.targetStatus == 'REPEAT' && form.payStatus !== 'NORMAL') : true })
const isDisabledRepeat = computed(() => { return targetInfo?.targetInfo?.targetStatus != 'REPEAT' && targetInfo.payTarget.length == 0 })
const clickImage = (image: string) => {
    previewList.value = [image];
    showViewer.value = true;
};
const tabsTable = (payTarget: any) => {
    let start = (tabsPage.value - 1) * tabsPageSize.value
    if (start >= payTarget.length) start = 0
    let end = tabsPage.value * tabsPageSize.value
    if (end >= payTarget.length) end = payTarget.length
    return payTarget.slice(start, end)
}
const handleCurrentChange = (val: number) => {
    tabsPage.value = val
    activeName.value = tabsTable(payTarget.value).length > 0 ? tabsTable(payTarget.value)[0].id : ''
}
const statusChange = (val: any) => {
    if (val == 'NORMAL') {
        form.payTargetId = ''
    }
}
const submitAudit = (item: any) => {
    if (form.payTargetId == item.id) {
        form.payTargetId = ''
    } else {
        form.payTargetId = item.id
    }
}
const getImageUrl = (fileId: any) => {
  return fileId.cloudServiceType === '1' ? ossUrl + fileId.url : cosUrl + fileId.url;
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_tag, {
          class: "ml-2",
          effect: "plain",
          round: "",
          type: _unref(payStatus) == 'REPEAT' ? 'danger' : 'success'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(resultTitle[_unref(payStatus)]), 1)
          ]),
          _: 1
        }, 8, ["type"])
      ]),
      (__props.targetType !== 'COLLECTING')
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            inline: true,
            model: __props.form,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "审核结果" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    style: {"width":"150px"},
                    disabled: __props.targetType == 'audited',
                    onChange: statusChange,
                    modelValue: __props.form.payStatus,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.payStatus) = $event)),
                    placeholder: "审核结果",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "唯一理赔标的",
                        value: "NORMAL"
                      }),
                      _createVNode(_component_el_option, {
                        label: "重复理赔标的",
                        disabled: _unref(isDisabledRepeat),
                        value: "REPEAT"
                      }, null, 8, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(payTarget).length && _unref(isShowSimTarget))
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          modelValue: _unref(activeName),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : activeName = $event)),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsTable(_unref(payTarget)), (item, index) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                name: item.id,
                key: item.id
              }, {
                label: _withCtx(() => [
                  _createVNode(_component_el_badge, {
                    value: __props.form.payTargetId == item.id && __props.targetType !== 'audited' ? '已确认' : '',
                    class: "item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`标的${tabsPage.value == 1 ? index + 1 : ((tabsPage.value - 1) * _unref(tabsPageBase).pageSize) + index + 1}`), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("span", null, _toDisplayString(item.farmerName), 1)
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("span", null, _toDisplayString(item.policyNo1), 1)
                        ], 512), [
                          [_vShow, item.policyNo1]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("span", null, _toDisplayString(item.policyNo2), 1)
                        ], 512), [
                          [_vShow, item.policyNo2]
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("span", null, _toDisplayString(item.caseNo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("span", null, _toDisplayString(item.targetNo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("span", {
                            class: _normalizeClass(['font_b',(__props.targetType == 'AuditPage' || __props.targetType == 'COLLECTING') &&  (item.isExcThreshold ? 'red' : 'green')])
                          }, _toDisplayString((item.sim * 100).toFixed(2)) + "%", 3)
                        ])
                      ]),
                      (__props.form.payStatus == 'REPEAT')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _withDirectives(_createVNode(_component_el_button, {
                              plain: "",
                              onClick: ($event: any) => (submitAudit(item)),
                              type: "danger",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.form.payTargetId ==
                                item.id ? '已确认标的' : '确认标的'), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]), [
                              [_vShow, __props.targetType !== 'audited']
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (item.picInfoVoList && item.picInfoVoList.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.picInfoVoList, (pics, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "cowItem",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_22, _toDisplayString(setPicName(pics.picType)), 1),
                              _createElementVNode("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pics.fileIds, (value) => {
                                  return (_openBlock(), _createBlock(_component_el_image, {
                                    class: "cowImg",
                                    key: value.url,
                                    style: {"width":"100px","height":"100px"},
                                    src: getImageUrl(value),
                                    fit: "contain",
                                    onClick: ($event: any) => (clickImage(getImageUrl(value)))
                                  }, null, 8, ["src", "onClick"]))
                                }), 128))
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (item.otherFileInfoVoList && item.otherFileInfoVoList.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.otherFileInfoVoList, (items, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "cowItem",
                              key: index
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(otherDetail[items.fileType]), 1),
                                (items.fileType == '0')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.fileIds, (value) => {
                                        return (_openBlock(), _createBlock(_component_el_image, {
                                          class: "cowImg",
                                          key: value.url,
                                          style: {"width":"100px","height":"100px"},
                                          src: getImageUrl(value),
                                          fit: "contain",
                                          onClick: ($event: any) => (clickImage(getImageUrl(value)))
                                        }, null, 8, ["src", "onClick"]))
                                      }), 128))
                                    ]))
                                  : (items.fileType == '1')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.fileIds, (value) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: value.url,
                                            class: "mr10"
                                          }, [
                                            _createElementVNode("video", _hoisted_28, [
                                              _createElementVNode("source", {
                                                src: getImageUrl(value),
                                                type: "video/mp4"
                                              }, null, 8, _hoisted_29),
                                              _createTextVNode(" Your browser does not support the video tag. ")
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_unref(payTarget).length && _unref(isShowSimTarget) && (__props.targetType == 'AuditPage' || __props.targetType == 'COLLECTING'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "prev, pager, next",
            onCurrentChange: handleCurrentChange,
            "current-page": tabsPage.value,
            "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((tabsPage).value = $event)),
            "page-size": tabsPageSize.value,
            total: _unref(payTarget).length
          }, null, 8, ["current-page", "page-size", "total"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_31, [
      (showViewer.value)
        ? (_openBlock(), _createBlock(_component_el_image_viewer, {
            key: 0,
            "hide-on-click-modal": "",
            onClose: _cache[3] || (_cache[3] = () => { previewList.value.value = []; showViewer.value = false }),
            "url-list": previewList.value
          }, null, 8, ["url-list"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})